/*
  Style Values for use in JavaScript code

 */

export const COLORS = {
  'gray-100': '#f8fafb',
  'gray-200': '#f2f4f6',
  'gray-300': '#e8ecef',
  'gray-400': '#98a9bc',
  'gray-500': '#778ca2',

  'dark': '#2D3047',
  'dark-100': '#252631',
  'dark-200': '#1B1E24',
  'primary': '#1eb386',
  'white': '#ffffff',
  'blue': '#09AFFF',
  'red': '#F03F3F',
  'yellow': '#FFBA49',
  'indigo': '#745BCC',
  'orange': '#FE7D51',

  'primary-hues': '#E8F7F2',
  'red-hues': '#FEECEC',
  'blue-hues': '#E6F7FF',
  'yellow-hues': '#FFF6E9',
  'indigo-hues': '#F1EFFA',
  'orange-hues': '#FFF5F1',
  'dark-hues': '#EAEAEC',
  'gray-hues': '#F1F3F5'
};

export const MOBILE_WIDTH = 768;
